import React from 'react';
import PropTypes from 'prop-types';

import { MAX_GUESTS_REACHED } from 'bento-ordering/group_ordering/constants/groupOrder';
import { StyledGroupOrderWrapper } from 'bento-ordering/group_ordering/ui_components/GroupOrder';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import PrimaryCta from 'components/Buttons/PrimaryCta';

import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';

const GroupOrderJoinMaxGuestsReached = ({ handleClick }) => {
  return (
    <StyledGroupOrderWrapper>
      <StyledTypographyColorSectionNavLinkMain
        textAlign="center"
        component="h4"
        variant={ITEM_DESCRIPTION_AND_PRICES}
        marginBottom={2}
      >
        {MAX_GUESTS_REACHED.title}
      </StyledTypographyColorSectionNavLinkMain>

      <PrimaryCta
        label={MAX_GUESTS_REACHED.primaryButtonLabel}
        handleClick={handleClick}
        fullWidth
      />
    </StyledGroupOrderWrapper>
  );
};

GroupOrderJoinMaxGuestsReached.propTypes = {
  handleClick: PropTypes.func.isRequired
};

export default GroupOrderJoinMaxGuestsReached;
